import { render, staticRenderFns } from "./HorarioConfiguracao.vue?vue&type=template&id=2b777d42&scoped=true"
import script from "./HorarioConfiguracao.vue?vue&type=script&lang=ts"
export * from "./HorarioConfiguracao.vue?vue&type=script&lang=ts"
import style0 from "./HorarioConfiguracao.vue?vue&type=style&index=0&id=2b777d42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b777d42",
  null
  
)

export default component.exports